// Public identity is independent of persisted resource names and identifiers.
export const BRAND_NAME = "Click95";
export const BRAND_MARK = "C95";
export const ADMIN_PORTAL_TITLE = `${BRAND_NAME} — Admin Portal`;
export const CLIENT_PORTAL_TITLE = `${BRAND_NAME} — Client Portal`;

// Existing destinations remain active until the domain/email migration is ready.
// See docs/rebrand-click95.md for the replacement checklist.
export const BRAND_WEBSITE_URL = "https://propergoodsites.com";
export const SALES_EMAIL = "hello@propergoodsites.com";
export const DEFAULT_EMAIL_FROM = "alerts@notify.propergoodsites.com";
